import { FunctionComponent, useMemo } from 'react'
import { ContentLayout, ContentLayoutProps } from '@conexasaude/hero-web'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'

const CustomLayout: FunctionComponent<ContentLayoutProps> = ({
  children,
  ...props
}) => {
  const { user } = useAuthContext()
  const patientInfomation = useMemo(() => {
    return `ID: ${user?.patientId} | Clínica: ${user?.clinic?.name}`
  }, [user?.patientId, user?.clinic?.name])

  const headerSize = 72
  const menuSize = 56
  const floatingFooterSize = 80
  const contentPaddingTopSize = 16
  const descreaseTotal =
    headerSize + menuSize + floatingFooterSize + contentPaddingTopSize

  const hasFooter =
    props.hasPrimaryAction ||
    props.hasSecondaryAction ||
    props.hasNegativeAction

  return (
    <ContentLayout
      fullHeight={false}
      styles={{
        root: {
          minHeight: `calc(100vh - ${hasFooter ? descreaseTotal : '16'}px)`,
        },
      }}
      layoutFooterProps={{
        copyContent: user ? patientInfomation : null,
      }}
      {...props}
    >
      {children}
    </ContentLayout>
  )
}

export default CustomLayout
